import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { ROUTES } from '../routes.ts';
import type { PublicOrganization } from '@dermalink/shared';
import { practiceBrandingStyle } from '../hooks/usePublicOrganization.ts';
import logoIcon from '../assets/logo-icon-color.svg';
import styles from './PageLayout.module.css';

export function Copyright() {
  return (
    <p className={styles.copyright}>
      <img src={logoIcon} alt="" aria-hidden="true" className={styles.copyrightLogo} />
      &copy; {new Date().getFullYear()} Dermalink
      <span className={styles.footerDot}>·</span>
      <NavLink to={ROUTES.platformInfo} className={styles.footerLink}>Over het platform</NavLink>
      <span className={styles.footerDot}>·</span>
      <NavLink to={ROUTES.medicalDisclaimer} className={styles.footerLink}>Medische disclaimer</NavLink>
      <span className={styles.footerDot}>·</span>
      <NavLink to={ROUTES.userAgreement} className={styles.footerLink}>Gebruikersovereenkomst</NavLink>
      <span className={styles.footerDot}>·</span>
      <NavLink to={ROUTES.privacyPolicy} className={styles.footerLink}>Privacybeleid</NavLink>
    </p>
  );
}

interface PageLayoutProps {
  children: React.ReactNode;
  centerText?: boolean;
  /** Flat app background, no photo backdrop, top-aligned content. For long-form reading pages (legal docs). */
  plain?: boolean;
  /** Brands the page for this practice: its backdrop and brand colour. */
  practice?: PublicOrganization | null;
}

export function PageLayout({ children, centerText, plain, practice }: PageLayoutProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pageClass = plain ? `${styles.page} ${styles.pagePlain}` : styles.page;
  const mainClass = `${styles.main}${plain ? ` ${styles.mainTop}` : ''}${centerText ? ` ${styles.centerText}` : ''}`;
  return (
    <div className={pageClass} style={practiceBrandingStyle(practice)}>
      <main className={mainClass}>
        {children}
      </main>
      <footer className={styles.footer}>
        <Copyright />
      </footer>
    </div>
  );
}
